import { el, setChildren } from 'redom';

import MemberSelector from './selector';
import MemberCalendar from './calendar';

class MemberCalendarFacade {

  constructor(configuration) {

    this.memberId = configuration.memberId;
    this.onChange = configuration.onChange;

    this.memberSelector = new MemberSelector({
      memberId: this.memberId,
      onChange: this.handleMemberChange.bind(this)
    });

    this.memberCalendar = new MemberCalendar({
      memberId: this.memberId,
      facade: this
    });

    this.el = el('.member-calendar-facade-main', [
      this.memberCalendar
    ]);

  }

  handleMemberChange(memberId) {

    this.memberCalendar.setMemberId(memberId);

    this.onChange({
      memberId
    });

  }

  hideMemberCalendar() {

    setChildren(this.el, [this.memberSelector]);

  }

  showMemberCalendar() {

    setChildren(this.el, [this.memberCalendar]);

  }

}

export default MemberCalendarFacade;